import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError } from '../../../node_modules/rxjs/operators';
import { MainFiltersService } from '../_services/main-filters.service';
import { UserService } from '../_services';
@Injectable()
export class InterceptorHeader implements HttpInterceptor {
  constructor(private svcFilter: MainFiltersService, private userService: UserService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = localStorage.getItem('currentUser');
    if (user) {
      const userObj = JSON.parse(user); // convert to object
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${userObj.token}`,
          Filters: JSON.stringify({
            schoolId: this.svcFilter.globalFilterObj.schoolId,
            programId: this.svcFilter.globalFilterObj.programId,
            // countryId: this.svcFilter.globalFilterObj.countryId,
            academicYearId: this.svcFilter.globalFilterObj.academicYearId,
            academicProgramId: this.svcFilter.globalFilterObj.programId,
            educationalProgramId: this.svcFilter.globalFilterObj.educationalProgramId,
            academicSemesterId: this.svcFilter.globalFilterObj.academicSemesterId
          })
        }
      });
    }

    return next.handle(request).pipe(catchError((error, caught) => {
      // intercept the respons error and displace it to the console
      console.log(error);
      this.handleAuthError(error);
      return of(error);
    }) as any);
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // handle your auth error or rethrow
    if (err.status === 401) {
      // navigate /delete cookies or whatever
      // console.log('handled error ' + err.status);
      this.userService.logoutReset();
    }
    throw err;
  }
}
